import type { Column } from "ag-grid-community";
import clsx from "clsx";
import { type CSSProperties, type PropsWithChildren, type ReactNode, useEffect, useRef } from "react";

import style from "../styles/Cell.module.css";

export interface TableCellProps {
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  editor?: boolean;
  setTooltip?: (value: string, shouldDisplayTooltip?: () => boolean) => void;
  column?: Column;
  tooltipValue?: string;
  alignRight?: boolean;
}

/** @deprecated use TruncateText + truncate css instead. Also cells can't rarely be generic. */
export const TableCellWrapper = (props: PropsWithChildren<TableCellProps>) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!props.setTooltip) return;

    const tooltipText = props.tooltipValue ?? "";
    const shouldShowTooltip = () => {
      if (!ref.current) return false;
      return ref.current.scrollWidth > (props.column?.getActualWidth() ?? 0) - 5 * 2;
    };

    props.setTooltip(tooltipText, shouldShowTooltip);
  }, [props.setTooltip, props.tooltipValue, props.column, props]);

  return (
    <div ref={ref} className={style.cell}>
      {props.children && (
        <div className={clsx(props.className, { [style.right_aligned]: props.alignRight })} style={props.style}>
          {props.children}
        </div>
      )}
    </div>
  );
};
